import { render, staticRenderFns } from "./safe-record.vue?vue&type=template&id=1b15d044&scoped=true&"
import script from "./safe-record.vue?vue&type=script&lang=js&"
export * from "./safe-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b15d044",
  null
  
)

export default component.exports